// Auto-generated — run `pnpm --filter @shared/utils db:generate` to regenerate
import m0000 from './0000_soft_colleen_wing.sql';
import m0001 from './0001_quiet_glorian.sql';

export default {
  journal: {
    entries: [
      {
        idx: 0,
        version: '6',
        when: 1772830502783,
        tag: '0000_soft_colleen_wing',
        breakpoints: true
      },
      {
        idx: 1,
        version: '6',
        when: 1789476641321,
        tag: '0001_quiet_glorian',
        breakpoints: true
      }
    ]
  },
  migrations: {
    m0000,
    m0001
  }
};
